<template>
  <div>
     <b-button
      v-permission="'portal_cebas.credentialing.config.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      ref="grid"
      :service="service"
      route_name="/portal-cebas/credentialings/configs"
      order_column="created_at"
      direction="desc">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="legal_entity_name" sort-key="legal_entity_id">{{$t('portal_cebas.credentialing.legal_entity')}}</vs-th>
        <vs-th key="title" sort-key="title">{{ $t('portal_cebas.credentialing.title_page') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="40%" key="legal_entity_name">
            <div> {{ tr.legal_entity_name }}</div>
          </vs-td>
          <vs-td width="50%" key="title_page">
            <div> {{ tr.title_page }}</div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'portal_cebas.credentialing.config.edit'"
                @click="props.edit(props.data[indextr].id)"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                v-tooltip.top="{content: 'Editar Configuração',delay: { show: 100, hide: 100 }}"/>
                <!--
                <feather-icon
                  v-permission="'portal_cebas.credentialing.config.detail'"
                  @click="detail(props.data[indextr].id)"
                  icon="EyeIcon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                  v-tooltip.top="{content: 'Detalhar Configuração',delay: { show: 100, hide: 100 }}"/>
                -->
                <feather-icon
                  v-permission="'portal_cebas.credentialing.config.delete'"
                  @click="props.destroy(props.data[indextr])"
                  icon="Trash2Icon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                  v-tooltip.top="{content: 'Excluir Configuração',delay: { show: 100, hide: 100 }}"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SelectSuggestion from '@/components/SelectSuggestion.vue'

import CebasCredentialingConfigService from '@/services/api/cebas/CebasCredentialingConfigService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    SelectSuggestion
  },
  data: () => ({
    selected: [],
    service: null,
  }),
  watch: {

  },
  computed: {

  },
  methods: {
    addNew() {
      this.$router.push('/portal-cebas/credentialings/configs/create')
    },
    detail(id) {
      this.$router.push({
        name: 'portal-cebas-credentialing-config-detail',
        params: {
          id: id
        }
      })
    },
    buildLink(link){
      return `${this.protocolLocation()}/#/portal-cebas/credentialings/pub/${link}`
    },
    reloadGrid(){
      this.$refs.grid.fetchGridData()
    },
  },
  beforeMount() {
    this.service = CebasCredentialingConfigService.build(this.$vs)
  }
}
</script>
